// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const EmployeeTypes:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'userTypes' , hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.settings.employeeTypes.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="userTypes"
    sortingMode="multiple"
  />;
}

function EmployeeTypesPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<EmployeeTypes hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default EmployeeTypesPortal;
